import { render } from "./BookPuton.vue?vue&type=template&id=4a90ef1c&scoped=true"
import script from "./BookPuton.vue?vue&type=script&lang=js"
export * from "./BookPuton.vue?vue&type=script&lang=js"

import "./BookPuton.vue?vue&type=style&index=0&id=4a90ef1c&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a90ef1c"]])

export default __exports__